import React, { Component } from "react";
import { HashRouter as Router, Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./index.scss";
export class EditionCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const edition = this.props.edition;
    const type = edition.type || "TALK";
    const title = edition.title || "EDITION ".concat(edition.id, " ");
    const startTime = new Date(edition.startTime);
    const endTime = new Date(edition.endTime);
    const formattedDate = startTime.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric"
    });
    const duration = Math.abs(startTime - endTime) / 36e5;
    const sessions = (edition === null || edition === void 0 ? void 0 : edition.sessions) || [];
    const sessionCount = (sessions === null || sessions === void 0 ? void 0 : sessions.length) || 0;

    const getTalksCount = sessions => {
      let count = 0;
      sessions.map(session => count += session.talks.length);
      return count;
    };

    const talksCount = getTalksCount(sessions) || 0;
    return /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Link, {
      key: edition.id,
      className: "editionCard event-bg",
      to: "./edition?editionId=".concat(edition.id)
    }, /*#__PURE__*/React.createElement("span", {
      className: "type"
    }, type.toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "details"
    }, /*#__PURE__*/React.createElement("p", {
      className: "title"
    }, title), /*#__PURE__*/React.createElement("p", {
      className: "date"
    }, "Edition ", edition.id, " | ", formattedDate), /*#__PURE__*/React.createElement("div", {
      className: "info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item"
    }, /*#__PURE__*/React.createElement("p", {
      className: "value"
    }, String(talksCount).padStart(2, "0")), /*#__PURE__*/React.createElement("p", null, talksCount > 1 ? "Talks" : "Talk")), /*#__PURE__*/React.createElement("div", {
      className: "item"
    }, /*#__PURE__*/React.createElement("p", {
      className: "separator"
    }), /*#__PURE__*/React.createElement("p", {
      className: "value"
    }, String(sessionCount).padStart(2, "0")), /*#__PURE__*/React.createElement("p", null, sessionCount > 1 ? "Sessions" : "Session")), /*#__PURE__*/React.createElement("div", {
      className: "item"
    }, /*#__PURE__*/React.createElement("p", {
      className: "separator"
    }), /*#__PURE__*/React.createElement("p", {
      className: "value"
    }, String(duration).padStart(2, "0"), " ", duration > 1 ? "hrs" : "hr"), /*#__PURE__*/React.createElement("p", null, "Duration"))))));
  }

}
EditionCard.propTypes = {
  edition: PropTypes.object.isRequired
};